import { Injectable } from '@angular/core';
import { Http, Headers, ResponseContentType, URLSearchParams } from '@angular/http';
import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';

@Injectable()
export class PagaresService {

  private service_url: string = null;

  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService
  ) {
      this.service_url = this.constantsService.apiURL + '/pagares';
  }

  // Método privado auxiliar para obtener headers de autenticación
  private getHeaders() {
      let headers = new Headers();
      headers.append('Authorization', 'Bearer ' + this.authService.getToken());
      headers.append('Content-Type', 'application/json');
      return headers;
  }

  // Obtener listado con paginación, tamaño de página y filtros de búsqueda específicos
  obtenerPagares(page: number, pageSize: number = 10, folio: string = "", inversionista: string = "") {
    let params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('per_page', pageSize.toString());
    params.append('folio', folio);
    params.append('inversionista', inversionista);

    return this.http.get(this.service_url, { 
      headers: this.getHeaders(), 
      search: params 
    });
  }

  // Obtener KPIs para las tarjetas superiores
  getKpis() {
    return this.http.get(`${this.service_url}/kpis`, { headers: this.getHeaders() });
  }
  
  // Descargar documento de pagaré
  public download(idPagare: number) {
    let options = {
        headers: this.getHeaders(),
        params: new URLSearchParams(),
        responseType: ResponseContentType.Blob
    };
    
    options.params.append('action', 'download');

    return this.http.get(`${this.service_url}/${idPagare}`, options);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/pagares.service.ts